import { render, staticRenderFns } from "./ProductCapacities.vue?vue&type=template&id=933edc50&scoped=true&"
import script from "./ProductCapacities.vue?vue&type=script&lang=js&"
export * from "./ProductCapacities.vue?vue&type=script&lang=js&"
import style0 from "./ProductCapacities.vue?vue&type=style&index=0&id=933edc50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933edc50",
  null
  
)

export default component.exports